/* @flow */
import { createStore, applyMiddleware } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import { routerMiddleware } from 'react-router-redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { autoRehydrate } from 'redux-persist-immutable';

import { rootReducer, rootEpic } from 'modules/index.js';
import { createAjax, LoggerConfig } from 'trustar/utils/redux-utils';

/**
 * NOTE: We turned off logging in autoRehydrate because it was noisy and not
 * causing any real problems. It will end up telling you that many actions are
 * being dispatched before rehydrate has a chance to fire, which is fine, but
 * the lib will complain.
 */
export default (browserHistory: any) => {
  const ajax = createAjax();
  const localStorage = window.localStorage;

  const epicMiddleware = createEpicMiddleware(rootEpic, {
    dependencies: { ajax, localStorage },
  });

  const middlewares = [epicMiddleware, routerMiddleware(browserHistory)];

  /* Configure Redux Logger */
  if (process.env.NODE_ENV === `development`) {
    const { createLogger } = require('redux-logger');
    const logger = createLogger(LoggerConfig);
    middlewares.push(logger);
  }

  const store = createStore(
    rootReducer,
    composeWithDevTools(
      applyMiddleware(...middlewares),
      autoRehydrate({ log: false }) // See NOTE
    )
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/app/createStore.js